// Imports => React
import { useMemo } from 'react';
import {withStore} from '@stores';
import {observer} from 'mobx-react-lite';

// Imports => Constants
import {
  AcEmptyBlock,
  KEYS,
} from '@opp/ui-kit';

// Imports => Utilities
import {
  AcIsSet,
} from '@opp/ui-kit';

// Imports => Atoms
import {
  AcRow,
  AcColumn,
} from '@opp/ui-kit';
import AcChangelogListItem from '@atoms/ac-changelog-list-item/ac-changelog-list-item';

const AcTransactionDetailsChangelogTab = ({statuses}) => {

  const renderLogItems = useMemo(() => {
    if (!AcIsSet(statuses)) {
      return <AcEmptyBlock
        message={`No changelog found.`}
      />;
    }

    const collection = statuses.slice().reverse();
    const len = collection.length;
    let n = 0;
    let result = [];

    for (n; n < len; n++) {
      const item = collection[n];

      const object = <AcChangelogListItem data={item} />;

      result.push(object);
    }

    return result;
  }, [statuses]);

  return (
    <AcRow>
      <AcColumn xs={12}>
        {renderLogItems}
      </AcColumn>
    </AcRow>
  );
};

export default withStore(observer(AcTransactionDetailsChangelogTab));
